
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/gifts/sent",
      function () {
        return require("private-next-pages/my/gifts/sent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/gifts/sent"])
      });
    }
  